export const MAX_ATTEMPT_COUNT = 5;
export const GAME_STATUS = {
  WIN: "WIN",
  LOSE: "LOSE",
  START: "START",
};
